"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.PageSwitchDefaultProps = exports.PageSwitch = void 0;

var _pageSwitch = _interopRequireDefault(require("./components/page-switch"));

exports.PageSwitch = _pageSwitch["default"];

var _pageSwitch2 = _interopRequireDefault(require("./components/page-switch.props/page-switch.defaultProps"));

exports.PageSwitchDefaultProps = _pageSwitch2["default"];